<script lang="ts" setup>
import { DriverStatus } from "@/constants/user";
import { useI18n } from "vue-i18n";
import { watch } from "vue";

const { t } = useI18n();

const model = defineModel<DriverStatus>({ default: DriverStatus.Active });

const options = [
  { id: DriverStatus.Active, name: t("drivers.status-a") },
  { id: DriverStatus.NotActive, name: t("drivers.status-n") },
  { id: DriverStatus.OnHold, name: t("drivers.status-h") },
  {
    id: DriverStatus.OnSilentHold,
    name: t("drivers.status-s"),
  },
];

const props = withDefaults(
  defineProps<{
    rules?: any[];
  }>(),
  {
    rules: () => [],
  },
);

watch(
  () => model.value,
  (newValue) => {
    if (newValue == DriverStatus.NotDriver) {
      model.value = DriverStatus.Active;
    }
  },
  {
    immediate: true,
  },
);
</script>

<template>
  <v-select
    id="driver_status"
    v-model="model"
    :items="options"
    :label="t('drivers.driver-status')"
    :rules="props.rules"
    autocomplete="off"
    class="mb-0 width-100"
    color="primary"
    density="compact"
    hide-details="auto"
    item-title="name"
    item-value="id"
    variant="outlined"
  />
</template>
